import api from '@/api/app'
const room = {
  room: {
    viewInfo: {
      obj: {

      },
      data: {

      }
    },
    control: {
      /**
             * 当前操作 是否是编辑用户
             * @date 2021-04-23
             * @param {any} condition //条件数组
             * @returns {any}
             */
      isEdit: (condition) => {
        return condition[0] == 2
      }
    },
    init: {
      initConfigs: [
        {
          label: 'searchData1',
          model: null
        },
        {
          label: 'searchData2',
          model: null
        },
        {
          label: 'searchData3',
          model: null
        },
        {
          label: 'searchData4',
          model: 'params'
        },
        {
          label: 'notesData5',
          model: 'params'
        },
        {
          label: 'notesData6',
          model: 'params'
        },
        {
          label: 'notesData7',
          model: 'params'
        }
      ],
      spaceTypes: () => {
        return new Promise((resolve) => {
          api.square.retrieve.conditions().then((res) => {
            if (res.data.length) {
              res.data.map((item1, index1) => {
                if (index1 == 1) {
                  item1.children.splice(3)
                }
                if (index1 == 2) {
                  item1.children.splice(3)
                }
              })
              res.data.map((item, index) => {
                if (item.children.length) {
                  item.children.map((child) => {
                    child.type = 'search'
                  })
                  item.children.push({
                    name: 'right',
                    type: 'route'
                  })
                }
              })
            }
            resolve(res.data)
          })
        })
      },
      spaces: (obj) => {
        return new Promise((resolve) => {
          api.room.retrieve.data(obj).then((res) => {
            if (res.data.data.length) {
              res.data.data.map(item => {
                item.dataType = 'true'
                item.cover_pic = item.img_urls
              })
            }
            resolve(res.data)
          })
        })
      },
      spaces1: (obj) => {
        return new Promise((resolve) => {
          api.mine.retrieve.collect(obj).then((res) => {
            if (res.data.data.length) {
              res.data.data.map(item => {
                item.dataType = 'true'
                item.dtoId = item.collection_id
              })
            }
            resolve(res.data)
          })
        })
      }
    }
  }
}
export default room
